import { render, staticRenderFns } from "./Benefactor.vue?vue&type=template&id=4be5bf9a"
import script from "./Benefactor.vue?vue&type=script&lang=js"
export * from "./Benefactor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports